import { LayoutDashboard, Database, Layers, FileText, History, Users, Zap } from 'lucide-react';

import logoFull from '@/assets/logo/artboard-1-300x107.png';
import logoWhite from '@/assets/logo/GCC-logo-3inch-white.png';

/**
 * appConfig - Master System Configuration.
 */
export const appConfig = {
    brand: {
        title: "Grimmius",
        accentTitle: "Cattle Co.",
        subtitle: "Authorized Team Only",
        initials: "GCC",
        logoFull,
        logoSymbol: logoWhite,
        logoAlt: "Grimmius Cattle Co. Logo"
    },
    navigation: [
        { path: '/catalogs', label: 'Catalogs', icon: Layers, requiredRole: 'ADMIN' },
        { path: '/reports', label: 'Reports', icon: FileText, requiredRole: 'ADMIN' },
        { path: '/audit', label: 'Audit', icon: History, requiredRole: 'ADMIN' },
        { path: '/team', label: 'Team', icon: Users, requiredRole: 'ADMIN' },
        { path: '/terminal', label: 'Terminal', icon: Zap },
    ],
    defaultUser: {
        name: 'Frankero',
        role: 'Admin',
        initials: 'FR',
        avatarColor: 'bg-white/10'
    },
    toast: {
        position: 'bottom-right',
        duration: 4000,
        style: {
            background: '#fff',
            color: '#0F172A',
            borderRadius: '1rem',
            padding: '16px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            border: '1px solid #f1f5f9',
            fontWeight: '500'
        },
        success: {
            iconTheme: {
                primary: '#009B9E', // Keep success color for semantics
                secondary: '#fff',
            },
        },
    },
    inventory: {
        defaultCategory: 'All',
        maxCategories: 8
    },
    // Theme Centralization for Inventory Flow Sys
    theme: {
        fontFamily: {
            sans: 'Inter, sans-serif',
        },
        colors: {
            primary: '#1A1C1E',      // Industrial Carbon Black
            primaryDark: '#0F1012',  // Deep Black
            accent: '#FFB800',       // Machinery Yellow (Industrial Highlight)
            secondary: '#334155',    // Slate Grey
            surface: '#F8F9FA',      // Panel Background
            background: '#FFFFFF',   // General Background
            text: '#1A1C1E'          // Base Text
        }
    }
};

